import * as React from "react";
import { useTranslation } from "react-i18next";

import CommonContainer from "../../../components/common/container/CommonContainer";
import SalesInventory from "../../../components/ShopOwner/Inventory/SalesInventory";

const SalesInventoryPage: React.FC<{}> = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const { t } = useTranslation("translation");

  return (
    <>
      <CommonContainer
        title={t("salesInventoryPageTitle")}
        description={t("salesInventoryPageDescription")}
        backButtonurl='/shopOwner/fetchInventories'
      >
        <SalesInventory />
      </CommonContainer>
    </>
  );
};

export default SalesInventoryPage;
